export default "__VITE_ASSET__DeyhHyJp__"